export default __webpack_public_path__ + "static/media/Bracers of Deadly Guile.b650ec91.jpg";